"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TokenFetcher = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _logger = require("../logger");
var _TokenFetcher;
const hashFromKeys = ['method', 'headers', 'url'];
const logger = _logger.mainLogger.createChild('TokenFetcher');

/**
 * Token fetching implementation. Handles multiple active requests
 */
class TokenFetcher {
  /**
   * Gets current request storage
   */
  static getStorage() {
    // Check build out
    const storageSpace = globalThis;
    if (!storageSpace.ori?._tokenRequestsStorage) {
      if (!storageSpace.ori) {
        storageSpace.ori = {};
      }
      storageSpace.ori._tokenRequestsStorage = new Map();
    }
    return storageSpace.ori._tokenRequestsStorage;
  }

  // NOTICE - making changes to output of this function may result in breaking change!
  /**
   * Hashes request options into storage key
   */
  static createStorageKey(options) {
    const objectToHash = {};
    for (const key of hashFromKeys) {
      if (key in options) {
        objectToHash[key] = options[key];
      }
    }
    return JSON.stringify(objectToHash).toLowerCase();
  }
  static isStorageItemMissing(key) {
    const storage = this.getStorage();
    const itemResolved = storage.get(key);
    return itemResolved === undefined;
  }

  /**
   * Checks if existing is valid, if not found then returns true
   */
  static async isStorageItemExpired(key) {
    const storage = this.getStorage();
    const itemResolved = await storage.get(key);

    // This could happen if request is not successful
    if (itemResolved === null) {
      return false;
    }

    // item is missing in storage
    if (!itemResolved) {
      return true;
    }
    return Date.parse(itemResolved.ExpirationDate) <= Date.now();
  }

  /**
   * Gets existing item or creates a new from factory
   */
  static async upsertStorageItem(key, factory) {
    const storage = this.getStorage();

    // We have to check for missing as fast possible(not async),
    // Having await before initial set to storage will result in multiple promises created
    if (this.isStorageItemMissing(key) || (await this.isStorageItemExpired(key))) {
      storage.set(key, factory());
    }

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- it's definitelly there since we checked :)
    return storage.get(key);
  }

  /**
   * Deletes item from storage by key. Returns true if it was found and deleted, false othervise
   */
  static removeStorageItem(key) {
    const storage = this.getStorage();
    return storage.delete(key);
  }

  /**
   * clears storage from all promises
   */
  static clearStorage() {
    if (globalThis.ori?._tokenRequestsStorage) {
      globalThis.ori._tokenRequestsStorage = undefined;
    }
  }

  /**
   * Fetches token with provided options. It keeps track of already made requests and does not try to fetch again
   */
}
exports.TokenFetcher = TokenFetcher;
_TokenFetcher = TokenFetcher;
(0, _defineProperty2.default)(TokenFetcher, "DEFAULT_REQUEST_OPTIONS", {
  credentials: 'same-origin',
  headers: {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- HTTP header name
    'X-Fetch-Api': '1',
    // eslint-disable-next-line @typescript-eslint/naming-convention -- HTTP header name
    'X-Requested-With': 'XMLHttpRequest'
  },
  method: 'GET'
});
(0, _defineProperty2.default)(TokenFetcher, "fetch", async options => {
  const {
    url,
    ...requestOptions
  } = options;
  const key = _TokenFetcher.createStorageKey(options);
  return _TokenFetcher.upsertStorageItem(key, async () => {
    // TODO - what about retries in case of network errors?
    const response = await fetch(url, requestOptions);
    if (response.status >= 500) {
      _TokenFetcher.removeStorageItem(key);
      throw new Error(`Token request ${url} failed on server or network error with status ${response.statusText}(${response.status})`);
    }
    if (!response.ok) {
      logger.warn(`Token request ${url} failed with status ${response.statusText}(${response.status})`);
      return null;
    }
    const result = await response.json();
    if (result.ExpirationSeconds != null) {
      const expirationDate = new Date();
      expirationDate.setSeconds(expirationDate.getSeconds() + result.ExpirationSeconds);
      return {
        ...result,
        ExpirationDate: expirationDate.toISOString()
      };
    }
    return result;
  });
});
